import { clientesApi } from "page/OrderResumePag/_services/api";

export async function updateCustomerEmail(cpf, email) {
  const response = await clientesApi.put(`/customer/${cpf}`, { email });
  return response;
}
